import { render, staticRenderFns } from "./preview-not-available-icon-sm.vue?vue&type=template&id=2097ece2"
import script from "./preview-not-available-icon-sm.vue?vue&type=script&lang=js"
export * from "./preview-not-available-icon-sm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports